import { getNotificationCountAPI } from '@services/notification';
import { create } from 'zustand';

export const useNotification = create((set) => ({
  count: 0,
  resetNotificationCount: () => {
    set({ count: 0 });
  },
  decrementCount: (by) => {
    const n = Number(by) || 0;
    if (n <= 0) return;
    set((state) => ({ count: Math.max(0, state.count - n) }));
  },
  getNotifications: async () => {
    try {
      const res = await getNotificationCountAPI();
      if (res.isOk && res.notif_count != null) {
        set({ count: Number(res.notif_count) || 0 });
      }
    } catch (e) {}
  }
}));
